/**
 * Two things the job screen needs that `repo.job` does not carry: when the job
 * was finished, and the site's address. Both are read straight off the rows the
 * device is holding, read-only.
 */
import * as store from "./store";
import type { SiteLocation } from "./navigate";

export type JobExtras = { completed_at: string | null; site: (SiteLocation & { name: string | null }) | null };

export async function readJobExtras(jobId: string): Promise<JobExtras> {
  const job = await store.get<store.Row>("job", jobId);
  const siteId = typeof job?.site_id === "string" ? job.site_id : "";
  const site = siteId ? await store.get<store.Row>("site", siteId) : undefined;
  return {
    completed_at: typeof job?.completed_at === "string" ? job.completed_at : null,
    site: site
      ? {
          name: typeof site.name === "string" ? site.name : null,
          address_line: (site.address_line as string | null) ?? null,
          suburb: (site.suburb as string | null) ?? null,
          state: (site.state as string | null) ?? null,
          postcode: (site.postcode as string | null) ?? null,
          latitude: (site.latitude ?? site.lat ?? null) as number | string | null,
          longitude: (site.longitude ?? site.lng ?? site.lon ?? null) as number | string | null,
        }
      : null,
  };
}
